let download = {
  title:"Rabbit VPN supports devices on multiple platforms",
  explain: "Select your platform and enable RabbitVPN to protect your privacy and security",
  system: {
    windows: "Windows",
    macOS: "macOS",
    android: "Android",
    iOS: "iOS"
  },
  eqDesp: "Scan QR code to download",
  second_title: {
    title_1: "A VPN APP That",
    title_2: "Puts Your Privacy",
    title_3: "First."
  },
  description: "Our apps are designed to keep your Internet connection secure and private, prevent your ISP and"
    + " government from spying on you and the websites you visit from identifying and tracking you, and to beat"
    + " censorship and provide a free and open Internet for all.",
  download_btn: "Download Rabbit VPN",
  download_title: "Simple And Fast VPN",
  download_desp: "Free VPN to use quickly without email",
  content: {
    download: "Download",
    install: "Install",
    enable: "Enable VPN",
    use: "Use"
  }
}
export default download


// WEBPACK FOOTER //
// ./src/assets/lang/en/new_download/index.js